/* eslint-disable @typescript-eslint/naming-convention */ import { getCreateConversationPayload, getFeedbackPayload } from 'api/ai-chat/utils';
import { HttpClient } from 'api/http-client';
class AskAiHttpClient extends HttpClient {
    async createConversation({ message, projectId }) {
        return this.post('/chat/create', getCreateConversationPayload({
            message,
            projectId
        }));
    }
    async sendMessage(payload) {
        return this.post('/chat', payload);
    }
    async getAllConversations(params) {
        const { offset, limit, agent_type } = params;
        const searchParams = new URLSearchParams({
            page: offset === 0 ? '1' : (offset / limit + 1).toString(),
            page_size: limit.toString()
        });
        if (agent_type) {
            searchParams.append('meta_data__agent_type', agent_type);
        }
        return this.get('/chat/conversations', {
            params: searchParams
        });
    }
    async getConversation(params) {
        var _params_page, _params_page_size, _response_has_more, _ref, _response_page, _ref1, _response_page_size, _response_total;
        const response = await this.get(`/chat/conversations/${params.conversation_id}`, {
            params: {
                page: (_params_page = params.page) !== null && _params_page !== void 0 ? _params_page : 1,
                page_size: (_params_page_size = params.page_size) !== null && _params_page_size !== void 0 ? _params_page_size : 100
            }
        });
        return {
            ...response.conversation,
            messages: response.messages,
            has_more: (_response_has_more = response.has_more) !== null && _response_has_more !== void 0 ? _response_has_more : false,
            page: (_ref = (_response_page = response.page) !== null && _response_page !== void 0 ? _response_page : params.page) !== null && _ref !== void 0 ? _ref : 1,
            page_size: (_ref1 = (_response_page_size = response.page_size) !== null && _response_page_size !== void 0 ? _response_page_size : params.page_size) !== null && _ref1 !== void 0 ? _ref1 : 100,
            total: (_response_total = response.total) !== null && _response_total !== void 0 ? _response_total : 0
        };
    }
    async sendFeedback(params) {
        const payload = getFeedbackPayload(params);
        await this.post('/chat/feedback', payload);
    }
    async updateFeedback(params) {
        const payload = getFeedbackPayload(params);
        await this.put('/chat/feedback', payload);
    }
}
export const askAiHttpClient = new AskAiHttpClient();
